import {
  MantineProvider,
  MantineTheme,
  MantineThemeOverride,
} from "@mantine/core";
import { MantineEmotionProvider } from "@mantine/emotion";
import { useCookies } from "react-cookie";
import { ModalsProvider } from "@mantine/modals";

import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

export const theme: MantineThemeOverride = {
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, 'Montserrat Classic', Montserrat, Kollektif",
  // fontFamily: "Helvetica",
  colors: {
    "genderlab-red": [
      "#FCE9E9",
      "#F6C1C1",
      "#F09999",
      "#EA7171",
      "#E44949",
      "#DE2121",
      "#B21A1A",
      "#851414",
      "#590D0D",
      "#2C0707",
    ],
  },
  primaryColor: "genderlab-red",
  components: {
    InputWrapper: {
      styles: (theme: MantineTheme) => ({
        label: {
          fontWeight: 400,
          color: "#495057",
        },
      }),
    },
  },
};

interface ThemeProviderProps {
  children: React.ReactNode;
}

const PRIMARY_THEME = "light";

export function ThemeProvider({ children }: ThemeProviderProps) {
  const [cookies] = useCookies(["colorScheme"]);

  return (
    <MantineProvider
      theme={theme}
      defaultColorScheme={cookies.colorScheme || PRIMARY_THEME}
    >
      <MantineEmotionProvider>
        <ModalsProvider>{children}</ModalsProvider>
      </MantineEmotionProvider>
    </MantineProvider>
  );
}
